module.exports = (obj, saveData) => {
  // order ==> 筛选的状态 asc/desc/
  // key ==> 当前筛选列的key值
  const key = obj.key;
  const order = obj.order;
  const data = saveData;
  if (order === 'normal') {
    return data;
  }
  const sortData = data.map((x) => {
    const copy = x;
    //用户分群根据状态排序的特殊处理
    if (key === 'status' && copy.status === 'STABLE') {
      copy.sort = 1;
      return copy;
    } else if (key === 'status' && copy.status === 'INIT') {
      copy.sort = 2;
      return copy;
    }
    if (key === 'userCount' && copy.userCount === null) {
      copy.sort = -2;
      return copy;
    }
    copy.sort = !copy[key] ? -1 : copy[key].toString().replace(/\W/g, '');
    return copy;
  });
  if (order === 'asc') {
    sortData.sort((a, b) => a.sort - b.sort);
  } else if (order === 'desc') {
    sortData.sort((a, b) => b.sort - a.sort);
  }
  return sortData;
};
